import { render, staticRenderFns } from "./VehicleModule.vue?vue&type=template&id=2580c1d5&scoped=true"
import script from "./VehicleModule.vue?vue&type=script&lang=ts"
export * from "./VehicleModule.vue?vue&type=script&lang=ts"
import style0 from "./VehicleModule.vue?vue&type=style&index=0&id=2580c1d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580c1d5",
  null
  
)

export default component.exports